import { differenceInCalendarDays, format, formatDistanceToNowStrict, parseISO } from 'date-fns';
import { uk } from 'date-fns/locale';

export function formatDate(value?: string | null, pattern = 'd MMM yyyy'): string {
  if (!value) return '—';
  return format(parseISO(value), pattern, { locale: uk });
}

export function formatDateTime(value?: string | null): string {
  if (!value) return '—';
  return format(parseISO(value), 'd MMM, HH:mm', { locale: uk });
}

export function formatTime(value?: string | null): string {
  if (!value) return '—';
  return format(parseISO(value), 'HH:mm');
}

export function fromNow(value?: string | null): string {
  if (!value) return '—';
  return formatDistanceToNowStrict(parseISO(value), { addSuffix: true, locale: uk });
}

/** 95 → "1 год 35 хв" */
export function formatDuration(minutes?: number | null): string {
  if (!minutes || minutes <= 0) return '0 хв';
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  if (!hours) return `${rest} хв`;
  if (!rest) return `${hours} год`;
  return `${hours} год ${rest} хв`;
}

export function formatMoney(amount: number, currency = 'UAH'): string {
  return new Intl.NumberFormat('uk-UA', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(amount);
}

export function daysUntil(value?: string | null): number | null {
  if (!value) return null;
  return differenceInCalendarDays(parseISO(value), new Date());
}

/** "через 3 дні" / "прострочено на 2 дні" for deadlines. */
export function deadlineLabel(value?: string | null): string {
  const days = daysUntil(value);
  if (days === null) return 'Без терміну';
  if (days === 0) return 'Сьогодні';
  if (days === 1) return 'Завтра';
  if (days === -1) return 'Прострочено на 1 день';
  if (days < 0) return `Прострочено на ${Math.abs(days)} дн.`;
  return `Через ${days} дн.`;
}

export function todayIso(): string {
  return format(new Date(), 'yyyy-MM-dd');
}
